// extracted by mini-css-extract-plugin
export default {"container":"NewsBlock_container__VDUvV","blockContainer":"NewsBlock_blockContainer__frt9z"};